import s from "styled-components";

export const Button = s.button`
  display: block;
  width: 100%;
  background: var(--grad-primary-n);
  border-radius: 7px;
  display: flex;
  align-items: center;
  padding: 10px 16px;
  box-shadow: ${({ theme }) => `0px 6px 20px 2px ${theme.color.primary}`};
  :focus {
    outline: none;
  }
  h2 {
		font-weight: 700;
    margin: 0;
    margin-left: 5px;
    color: white;
    font-size: 16px;
  }
`;
export const IconWrap = s.span`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  transition: transform .25s ease;
  transform: rotate(${({ isOpen }) => (isOpen ? "90deg" : "0deg")});
`;
